import { Injectable } from '@angular/core';
import { RunTimeDataService } from '@leandredev/common_ng_14';
import { I_Claim, I_Session } from 'src/app/utils/interfaces';
import { environment } from 'src/environments/environment';

const JWT_TOKKEN_STORAGE_KEY = environment.application_instance + 'jwToken';
const JWT_EXP_STORAGE_KEY = environment.application_instance + 'jwExp';
const STORE_SESSION_KEY = 'token';

@Injectable()
export class SessionService {
  public sessionId: string;

  constructor(private runTimeDataService: RunTimeDataService) {
    this.sessionId = Math.random().toString();
    this.patchSession(localStorage.getItem(JWT_TOKKEN_STORAGE_KEY), null);
  }

  public patchSession(token: string, userId: string, claim?: I_Claim): void {
    this.runTimeDataService.patchStore(STORE_SESSION_KEY, { token: token, userId: userId });
    if (token) localStorage.setItem(JWT_TOKKEN_STORAGE_KEY, token);
    if (claim) localStorage.setItem(JWT_EXP_STORAGE_KEY, String(Number(claim.exp)));
  }

  public clearSession(): void {
    this.runTimeDataService.updateStore(STORE_SESSION_KEY, null);
    localStorage.removeItem(JWT_TOKKEN_STORAGE_KEY);
    localStorage.removeItem(JWT_EXP_STORAGE_KEY);
  }

  get value(): I_Session {
    return this.runTimeDataService.getStore(STORE_SESSION_KEY) as I_Session;
  }

  public isExpired(): boolean {
    const expStr: string = localStorage.getItem(JWT_EXP_STORAGE_KEY);
    const idTokenStr: string = localStorage.getItem(JWT_TOKKEN_STORAGE_KEY);

    return !(idTokenStr && expStr && Number(expStr) * 1000 > Date.now());
  }
}
